@if (marketSalesDataService.estateSaleIsLoading()) {
    <div style="padding: 20px; display: flex; justify-content: center">
        <ev-logo-loader width="70px" />
    </div>
} @else if (canShowStatisticsData()) {
    <div class="price-statistics-wrapper">
        <div>
            <market-price-statistics [statistics]="statistics()"></market-price-statistics>
        </div>
    </div>
} @else if (!canShowStatisticsData()) {
    <div class="s-card">
        <span class="price-number">Zoom inn for &#229; vise statistikk</span>
    </div>
}
